import Lambda from "./Lambda";
import * as Lists from "./EInstances/Lists";
import Types from "./Types";
import "./EInstances/Functions";
import "./EInstances/MultivariateFunction";
import "./EInstances/ListFunction";

export default{
	Lambda,
	Lists,
	Types,
}
